import Vue from "vue";
import App from "./App.vue";
import "@mdi/font/css/materialdesignicons.css";
import "leaflet/dist/leaflet.css";
import Card from "@/components/Card.vue";
import router from "./router";
import index from "./store";
import Buefy from "buefy";
import * as settings from "@/appConfig";
import { abilitiesPlugin } from "@casl/vue";
import { AppAbilityChecker, AppAbilityService } from "@/appAbility";
import { roundNumber } from "@/utils/round";
import defaultDateFormat, { defaultDateTimeFormat } from "@/utils/defaultDateFormat";
import getCSSColor from "@/utils/getCSSColor";
import Multiselect from "vue-multiselect";
import { toTitleCase, toTitleFriendlyCase, toTitleCaseFromSnakeCase } from "@/utils/toTitleCase";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LRectangle } from "vue2-leaflet";
import { Icon } from "leaflet";
import getOrNoValue from "@/utils/getOrNoValue";
import { kilowattToMegawattAsObject } from "@/utils/kilowattToMegawattDisplay";
import VueCurrencyInput from "vue-currency-input";
import VueClipboard from "vue-clipboard2";
import { NO_VALUE_DISPLAY } from "@/appConfig";
import Draggable from "vuedraggable";
import { RoleEnum } from "@/classes/role";
import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

// Vue2Leaflet Configuration
type D = Icon.Default & {
  _getIconUrl: string;
};
// delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});
Vue.use(Buefy);
Vue.use(VueClipboard);
Vue.config.productionTip = false;
Vue.component("draggable", Draggable);
Vue.component("card", Card);
Vue.component("multiselect", Multiselect);
Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-popup", LPopup);
Vue.component("l-rectangle", LRectangle);
Vue.component("l-tooltip", LTooltip);
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: "USD"
  }
});
Vue.use(abilitiesPlugin, AppAbilityService);
Vue.component("vc-calendar", Calendar);
Vue.component("vc-date-picker", DatePicker);

Vue.mixin({
  computed: {
    ...AppAbilityChecker
  },
  methods: {
    getCSSColor,
    getOrNoValue,
    kilowattToMegawattAsObject,
    toTitleCase,
    toTitleCaseFromSnakeCase,
    toTitleFriendlyCase,
    prettify(str = "") {
      return JSON.stringify(JSON.parse(str || ""), undefined, 2);
    },
    notificationSuccess(message: string) {
      this.$buefy.toast.open({
        duration: 5000,
        message,
        position: "is-top",
        type: "is-success"
      });
    },
    notificationError(message: string) {
      this.$buefy.toast.open({
        duration: 5000,
        message,
        position: "is-top",
        type: "is-danger"
      });
    }
  },
  data: function() {
    return {
      RoleEnum,
      defaultDateFormat,
      defaultDateTimeFormat,
      settings,
      NO_VALUE_DISPLAY,
      roundNumber: roundNumber
    };
  }
});

new Vue({
  router,
  store: index,
  render: h => h(App)
}).$mount("#app");
